import React, { useEffect, useState } from "react";

import RatingStars from "./RatingStars";
import { getRatingAccentColor } from "./ratingPalette";

const PAGE_SIZE = 10;

function formatRatingNumber(value) {
   const number = Number(value);
   if (!Number.isFinite(number)) return "—";
   return number % 1 === 0 ? String(number) : number.toFixed(1);
}

function getRatingStudentName(user) {
   if (!user) return "Elev necunoscut";

   const first = String(user.firstName || "").trim();
   const last = String(user.lastName || "").trim();
   const full = `${first} ${last}`.trim();
   return full || user.email || "Elev necunoscut";
}

function getRatingDateLabel(rating) {
   const raw =
      rating?.reservation?.startTime ||
      rating?.reservation?.date ||
      rating?.createdAt ||
      rating?.updatedAt;
   if (!raw) return "";

   const date = new Date(raw);
   if (Number.isNaN(date.getTime())) return "";

   return date.toLocaleDateString("ro-RO", {
      day: "2-digit",
      month: "short",
      year: "numeric",
   });
}

function getRatingId(rating) {
   return (
      rating?.id ??
      `${rating?.reservationId || "r"}-${rating?.userId || "u"}-${rating?.createdAt || "c"}`
   );
}

export { getRatingPalette, getRatingAccentColor, getRatingCardStyle } from "./ratingPalette";

export default function InstructorRatingsRecentList({ ratings = [] }) {
   const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
   const visibleRatings = ratings.slice(0, visibleCount);
   const hasMore = visibleCount < ratings.length;

   useEffect(() => {
      setVisibleCount(PAGE_SIZE);
   }, [ratings]);

   if (!ratings.length) return null;

   return (
      <>
         <div className="instructorProfileUI__statsRecent">
            {visibleRatings.map((rating) => {
               const ratingId = getRatingId(rating);
               const comment = String(rating?.comment || "").trim();

               return (
                  <article
                     key={ratingId}
                     className="instructorProfileUI__statsRating"
                  >
                     <div className="instructorProfileUI__statsRatingHead">
                        <span className="instructorProfileUI__statsRatingName">
                           {getRatingStudentName(rating?.user)}
                        </span>
                        <span className="instructorProfileUI__statsRatingDate">
                           {getRatingDateLabel(rating)}
                        </span>
                     </div>
                     <div className="instructorProfileUI__statsRatingScore">
                        <RatingStars
                           value={rating?.rating}
                           size="sm"
                           accentColor={
                              getRatingAccentColor(rating?.rating) || undefined
                           }
                        />
                        <span className="instructorProfileUI__statsRatingValue">
                           {formatRatingNumber(rating?.rating)}
                        </span>
                     </div>
                     <p
                        className={`instructorProfileUI__statsRatingComment ${
                           comment ? "" : "is-empty"
                        }`}
                     >
                        {comment || "Fără comentariu."}
                     </p>
                  </article>
               );
            })}
         </div>

         {hasMore && (
            <button
               type="button"
               className="instructorProfileUI__statsLoadMore"
               onClick={() =>
                  setVisibleCount((current) => current + PAGE_SIZE)
               }
            >
               Încarcă încă 10
            </button>
         )}
      </>
   );
}
